module.exports = __webpack_public_path__ + "img/5.721d224e.png";